<template>
  <div class="modal fade" id="print-map-style-hint-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body p-5">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <h3><strong>Choose your background map</strong></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>Your printed sheets use whichever map style is on screen right now.</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="hint-button-example d-flex align-items-center justify-content-center my-3">
                  <span class="btn btn-sm rounded-pill d-flex align-items-center" aria-hidden="true">
                    <span class="d-flex align-items-center justify-content-center pr-1">
                      <span class="material-icons">layers</span>
                    </span>
                    <span>Maps</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p>Tap <strong>Maps</strong> above the map to switch between styles &mdash; standard, satellite, terrain and more &mdash; before you print.</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button type="button" class="btn btn-primary w-100" data-bs-dismiss="modal">Got it</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.hint-button-example {
  .btn {
    background-color: #000;
    color: #fff;
    padding: 0.35rem 0.9rem;
    pointer-events: none;

    .material-icons {
      font-size: 1.1rem;
    }
  }
}
</style>
